import { Component, OnInit, ElementRef, ViewChild, NgZone, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { MapsAPILoader } from '@agm/core';
import { RsbService } from 'src/app/service/rsb.service';
@Component({
  selector: 'app-my-properties',
  templateUrl: './my-properties.component.html',
  styleUrls: ['./my-properties.component.css']
})
export class MyPropertiesComponent implements OnInit {
  allListings:Array<any> = []
  constructor(
    private lookupModel: RsbLookupModel,
    private rsbService: RsbService
  ) { }

  ngOnInit(): void {
    this.getAllListings()
  }

  getAllListings(): void {
    this.rsbService.getUserListings().subscribe((rsp) => {
      if(rsp.statusCode === 0 && rsp.contents.length) {
        this.allListings = rsp.contents
      } else {
        this.allListings = []
      }
    })
  }

}
